import notificationReducer from './reducers';

export { default as notificationTypes } from './types';
export { default as notificationActions } from './actions';

export default notificationReducer;
